<template>
  <Modal 
    :id="'cmp_statements-email-statements'"
    @cancelled="onCancelClick"  
  >
   <template slot="header">
      Email Statement
    </template>
    <template slot="body">
  
        <div style="display:flex ;flex-direction:column"  >
            <div class="ut-fh" style="justify-content: space-between">
              <TextField
                  style="width:50%"
                  class="m1"
                  :id="'cc'"
                  v-bind="textFieldConfig"
                  :value="cc"
                  :placeholder="'cc'"
                  @valuechanged="onTextFieldValueChange"
               
              >
              </TextField>
              <TextField
                  class="m1"
                  style="width:50%"
                  :id="'bcc'"
                  v-bind="textFieldConfig"
                  :value="bcc"
                  :placeholder="'bcc'"
                  @valuechanged="onTextFieldValueChange"
               
              >
              </TextField>

            
            </div>
        <!-- @scrollnext="onReleasesNext" -->
            <div class="ut-fh ut-fc" style="max-height:300px;height:300px">
             <NTable
                id="catalog-releases-releases_list"
                class="h1 dbox1"
                :config="tableConfig"
                :headers="contactHeaders"
                :items="statementListEmail"                
            >
                <template v-slot:item="{ item, tdcon }">
                <tr>
                    <td style="border:0px" v-bind="tdcon('chk')">
                        <div class="checkbox-container">
                            <div class="dt-checkbox v2 s1">
                                <input
                                type="checkbox"
                                name="name"
                                :checked="selectedEmails.has(item['royalty_period_id'])"
                                @click="e => onCheckboxChange(e, 'name', item)"
                                />
                                <div class="checkmark"></div>
                            </div>
                        </div>
                    </td>
                    <td v-bind="tdcon('royalty_account_name')">
                   
                        <span>{{item['royalty_account_name']}}</span>
                    </td>

                    <td v-bind="tdcon('period')">
                      <span>{{periodSpace( item["period"]) }}</span>
                    </td>
                    <td v-bind="tdcon('email')">
                        <span class="txtov" :title="item['email']">{{item['email']}}</span>
                    </td>
                   
                    <td v-bind="tdcon('already_sent')">
                        <span>{{ item["already_sent"] }}</span>   
                    </td>
                
                    
                
                    
                </tr>
                </template>
            </NTable>
         

       
            </div>
        </div>
    </template>
    <template slot="options">

             
        
        <button class="dt-button s7 v1" @click="onSelectAll">Select All</button>
         <button class="dt-button s7 v1" style="margin-left:10px" @click="onSelectAllNotSentNone">Select All NOT SENT</button>
        <button class="dt-button s7" @click="onCancelClick">Cancel</button>
        <button class="dt-button s7 v1" @click="onOKClicked" style="margin-left: 10px;">OK</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';
import { RoyaltyStoreNamespace as storeNS } from "../../store";
// import { mapGetters, mapActions } from "vuex";
// import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
// import {
//   distinctUntilChanged,
//   debounceTime,
// } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

//import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { createModalMixin ,closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";





import { addRemoveSet, subscribeSubject } from '../../../../utility';



import {
  createTV,
 
} from "../../../../models/text-value.model";

import {
 
  mapActionObject, mapGetterObject,
} from "../../../../store/global";

import { statementActions } from '../../store/statement/actions';
import { statementServices } from '../../services/statements/statements.service';
import { HttpClient} from '../../../../services/http/http-client';
import { statementGetters } from '../../store/statement/getters';



export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    DTCheckbox,
    ModalContainer,
    Modal
    
   
  },
  props:['basicFilter'],
  mounted: async function () {
     const res=await statementServices.emailStatementsFormData({royalty_period_ids:this.listID, ...this.basicFilter});
     console.log("resData",res);

     this.statementListEmail=res.data.statements
 

    
 

  },
  data: function () {
    return {
    
     
      statementListEmail:[],
      selectedEmails:new Set(),
      searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search
      selectAllNone: false,
      selectAllNotSentNone: false,
      cc:'',
      bcc:'',
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      
      },
    };
  },
   mixins: [
    
   
    
    
    createModalMixin("checkContracts"),
    createModalMixin("confirmRoyalty"),
    createModalMixin("shopManagement"),
   
    
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
   ...mapGetterObject(storeNS,statementGetters),
    
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        headerStyle: 3
      });
    },
    listID: function() {
      return this.statementList?.statements.map(e=>e.royalty_period_id).join()||"";
    },

    contactHeaders: function () {
      return [
        createTableHeader("chk", { text:false,mw:30 }),
        createTableHeader("royalty_account_name", { f:1.1 }),
        createTableHeader("period", { f:1}),
        createTableHeader("email", {f:1.5 }),
       
        createTableHeader("already_sent", {f:0.5 ,ta:'center'}),

      ];
    },
  
  },
  methods: { 
   ...mapActionObject(storeNS, statementActions),

    periodSpace:function(periodString){

      const newArray = periodString.split("");
      newArray.splice(10, 0, " ");
      newArray.splice(12, 0, " ");
      return newArray.join("");
      // let currentHyphen=0;
      // let pString=""; 
      // for (let i = 0; i < periodString.length; i++) {
      //   if(periodString[i]=="-"){
      //     currentHyphen+=1;
      //     if(currentHyphen==3){
      //       periodString[i]=` - `
      //     }
      //   }

      //   pString+=periodString[i]
      // }

      // return pString;
    },

    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onOKClicked:function(){
        statementServices.emailStatements([...this.selectedEmails],this.statementListEmail.filter(e=>[...this.selectedEmails].includes(e['royalty_period_id'])&&e.royalty_period_bundle_id).map(e=>e.royalty_period_bundle_id),this.cc,this.bcc);
        this.onCancelClick();
    },
    onSelectAll:function(){
        
        if ( !this.selectAllNone) {
         this.selectAllNone = true;
         
         this.selectedEmails = new Set(this.statementListEmail.map(e => e.royalty_period_id));
         console.log("SET DATA",this.statementListEmail.map(e => e.royalty_period_id));
        } 
        else {
          this.selectAllNone = false;
          this.selectedEmails = new Set();
        }
    },
    onSelectAllNotSentNone:function(){
        if ( !this.selectAllNotSentNone) {
         this.selectAllNotSentNone = true;
         
         this.selectedEmails = new Set(this.statementListEmail.filter(e=>e.already_sent=='No').map(e => e.royalty_period_id));
        //  console.log(this.statementListEmail.filter(e=>[...this.selectedEmails].includes(e['royalty_period_id'])&&e.royalty_period_bundle_id).map(e=>e.royalty_period_bundle_id),"SET DATA",this.statementListEmail.filter(e=>e.already_sent=='Yes').map(e => e.royalty_period_id));
        } 
        else {
          this.selectAllNotSentNone = false;
          this.selectedEmails = new Set();
        }
    },
    onCheckboxChange:function(event, name, item){
      //const value = event.target.checked;
      this.selectedEmails = addRemoveSet(
        event.target.checked,
        this.selectedEmails,
        item.royalty_period_id
      );
      console.log("WWWW",this.selectedEmails,item);
    },
    onTextFieldValueChange: function (name, value) {    
      this[name]=value;

      // this.selectedProductMedia = {
      //   ...this.selectedProductMedia,
      //   [name]: value,
      // };
    },


  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
   // --offset: 190px;
   
  }
  td.file_name a {
  }
  .dt-page--data-table {
    //--offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>